import React from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";
import { colors } from "../../../../../utils";
import TextView from "../../../../TextView";

const TableHeader = ({ columnHeaders }) => {
  return (
    <TableHead
      sx={{
        backgroundColor: colors.background,
        height: 40,
        borderBottom: `3px solid ${colors.PrimaryPurple500}`,
      }}
    >
      <TableRow sx={{ height: 40 }}>
        {columnHeaders.map((column) => (
          <TableCell
            key={column.id}
            padding="none"
            sx={{
              width: column.width,
              paddingLeft: column.paddingLeft ? 2 : 0,
            }}
          >
            <TextView
              variant="text"
              style={{
                fontSize: "16px",
                fontWeight: 700,
              }}
            >
              {column.label}
            </TextView>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader; 